export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/engine-warpper.worker.d97bed4d.worker.js");
}
